import { Control, FieldPath } from "react-hook-form";
import { FormField } from "../FormField";
import { RegisterFormData } from "../schema";

interface PasswordFieldProps {
  name: FieldPath<RegisterFormData>;
  control: Control<RegisterFormData>;
  label: React.ReactNode;
  placeholder: string;
  showPassword: boolean;
  togglePassword: () => void;
}

export const PasswordField = ({
  name,
  control,
  label,
  placeholder,
  showPassword,
  togglePassword,
}: PasswordFieldProps) => {
  return (
    <FormField
      name={name}
      control={control}
      label={label}
      placeholder={placeholder}
      type="password"
      showPassword={showPassword}
      togglePassword={togglePassword}
    />
  );
};